const urlParams = () => {
  const { href } = window.location;
  const body = document.querySelector('body');

  // Add debug class to body when debug=1 is found in url
  if (href.split('debug=1').length > 1) {
    body.classList.add('debug');
  }

  // Add ledenservice class to body when ls=1 is found in url
  if (href.split('ls=1').length > 1) {
    body.classList.add('ledenservice');
  }

  // Add dev class to body when dev=1 is found in url
  if (href.split('dev=1').length > 1) {
    body.classList.add('dev');
  }
};

export default urlParams;
